import { createAPIService } from './api.service';

export const ORGANIZATIONS_ENDPOINT =
  '/organization/api/v1/admin/organizations';

const service = createAPIService(ORGANIZATIONS_ENDPOINT);

service.getOrganizations = async params =>
  (await service.get('', { params: params })).data;

service.getOrganization = async id => (await service.get(`/${id}`)).data;

service.createOrganization = async organization =>
  (await service.post('', organization)).data;

service.updateOrganization = async (id, organization) =>
  (await service.patch(`/${id}`, organization)).data;

export default service;
